import { SHOW_LOADER, HIDE_LOADER, CLEAR_ALL } from '../constants';

interface LoaderState {
  show: boolean;
  message: string;
}

const initialState: LoaderState = { show: false, message: '' };

const loaderReducer = (state = initialState, { type, payload }: { type: string; payload?: any }): LoaderState => {
  switch (type) {
    case SHOW_LOADER:
      return { show: true, message: payload || 'Loading...' };
    case HIDE_LOADER:
      return { show: false, message: '' };
    case CLEAR_ALL:
      return { ...initialState };
    default:
      return state;
  }
};

export default loaderReducer;
